module.exports = __webpack_public_path__ + "img/2000-betting.1f0f6f82.jpg";